module.exports = __webpack_public_path__ + "static/media/download.a9865db7.svg";